module.exports = __webpack_public_path__ + "static/media/portfolio2.11f04ded.jpg";